'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonDynamicVideo from '../CommonDynamicVideo';
import CommonContainer from '@components/CommonContainer';
import { Box } from '@mui/material';
import CommonDynamicHeading from '../CommonDynamicHeading';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
export default function TheResidencesBanner(
  props: MarketingPageComponentProps
) {
  return (
    <CommonDynamicVideo
      className={cn.theResidencesBanner}
      mobilePoster={props.images.residence_tower_banner_story_mobile?.src}
      desktopPoster={props.images.residence_tower_banner_story_desktop?.src}
      mobileVideo={props.videos?.residenceTowerBannerstoryMobile?.src}
      desktopVideo={props.videos?.residenceTowerBannerstoryDesktop?.src}
    >
      <CommonContainer
        paddingInline={{ xs: '32px', sm: '32px', md: '24px' }}
        maxWidth={{ xs: '100%', md: '1200px', lg: '1400px' }}
        flexGrow={1}
      >
        <Box className={cn.theResidencesContent}>
          <CommonDynamicHeading
            label={props.locale.section.residencesTowerBannerHeading}
          />
        </Box>
      </CommonContainer>
    </CommonDynamicVideo>
  );
}
